<template>
	<section v-if="isSectionContentFilled" class="car-rental-text-section">
		<div class="car-rental-text-section__content">
			<div v-if="sectionContent && sectionContent.content" class="car-rental-text-section__text">
				<template v-for="(node, index) in parsedContent" :key="index">
					<GlobalImage v-if="node.type === 'image'" :src="node.src || ''" :alt="node.alt || ''" quality="95" />
					<div v-else v-html="node.content"></div>
				</template>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
const { locale } = useI18n()
const pageTextSection = inject<Ref<ICMSLocationContent>>('pageTextSection')!
const sectionContent = ref<ICMSLocationContentTranslations>(
	pageTextSection.value?.translations.find((translation) => translation.language === locale.value)?.content[0],
)

const parsedContent = computed(() => {
	if (!sectionContent.value?.content || typeof sectionContent.value.content !== 'string') return []

	const content = sectionContent.value.content as string
	const nodes: Array<{ type: string; content?: string; src?: string; alt?: string }> = []

	const imgRegex = /<img[^>]+src="([^"]+)"[^>]*alt="([^"]*)"[^>]*>/g
	let match
	let lastIndex = 0

	while ((match = imgRegex.exec(content)) !== null) {
		if (match.index > lastIndex) {
			nodes.push({
				type: 'text',
				content: content.slice(lastIndex, match.index),
			})
		}

		nodes.push({
			type: 'image',
			src: match[1],
			alt: match[2],
		})

		lastIndex = match.index + match[0].length
	}

	if (lastIndex < content.length) {
		nodes.push({
			type: 'text',
			content: content.slice(lastIndex),
		})
	}

	return nodes
})

const isSectionContentFilled = computed(() => {
	if (sectionContent.value) {
		return sectionContent.value.content !== '' && sectionContent.value.content !== null
	}
	return false
})
</script>

<style lang="scss">
@import './TextSection.scss';
</style>
